import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './UserMockInterviewCompletionsSubTab.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function UserMockInterviewCompletionsSubTab() {
  const [completions, setCompletions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompletions();
  }, []);

  const fetchCompletions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/api/user-mock-interview-completions`);
      setCompletions(response.data);
      setError(null);
    } catch (err) {
      setError('Ошибка при загрузке статистики прохождений: ' + (err.response?.data?.detail || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Вы уверены, что хотите удалить эту запись о прохождении?')) {
      try {
        await axios.delete(`${API_URL}/api/user-mock-interview-completions/${id}`);
        fetchCompletions();
      } catch (err) {
        setError('Ошибка при удалении записи: ' + (err.response?.data?.detail || err.message));
      }
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return date.toLocaleString('ru-RU', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  };

  if (loading) {
    return <div className="loading">Загрузка...</div>;
  }

  return (
    <div className="user-mock-interview-completions-sub-tab">
      <div className="tab-header">
        <h3>Статистика прохождений пользовательских Mock-собеседований</h3>
        <button className="btn btn-secondary" onClick={fetchCompletions}>
          🔄 Обновить
        </button>
      </div>

      {error && <div className="error-message">{error}</div>}

      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Telegram ID</th>
              <th>ID собеседования</th>
              <th>Название собеседования</th>
              <th>Share ID</th>
              <th>Дата прохождения</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {completions.length === 0 ? (
              <tr>
                <td colSpan="7" className="empty-state">
                  Нет записей о прохождении пользовательских собеседований.
                </td>
              </tr>
            ) : (
              completions.map((completion) => (
                <tr key={completion.id}>
                  <td>{completion.id}</td>
                  <td>{completion.telegram_id}</td>
                  <td>{completion.interview_id}</td>
                  <td className="interview-title-cell">{completion.interview_title || '-'}</td>
                  <td className="share-id-cell">{completion.interview_share_id || '-'}</td>
                  <td>{formatDate(completion.completed_at)}</td>
                  <td>
                    <button
                      className="btn-icon btn-delete"
                      onClick={() => handleDelete(completion.id)}
                      title="Удалить"
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default UserMockInterviewCompletionsSubTab;
